import React, { useState, useEffect } from "react";
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";
import { regexConstants } from "../../../../constants/regEx";
import { gaTelesisInstance } from "../../../../shared/components";

const AddEditAircraftTypes = ({ params, toggleModalFn, addEditAircraftTypes, modeType, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [data, setData] = useState(addEditAircraftTypes?.data);
    const [error, setError] = useState({ modal: false, data: null })
    const [isLoading, setLoading] = useState(false);
    const [modelsInfo, setModelsInfo] = useState([]);
    const [aircraftFamilyInfo, setAircraftFamilyInfo] = useState([]);
    const [pltConstants, setPltConstants] = useState([])
    
    useEffect(() => {
        getPltConstants();
        if (modeType === 'add' || modeType === 'edit') {
            getModels();
            getAircraftFamily();
        }
    }, [])

    const getPltConstants = () => {
        globalGetService(`technical/blueprints/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let data = response.data.data.map(item => {return {label:item?.name, value:item?.id}}) 
                    setPltConstants(data)
                }
            })
    }

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }

    const getModels = () => {
        globalGetService(`config-data/aircraft-model/?lite=true`)
        .then(response => {
            if (checkApiStatus(response)) {
                setModelsInfo(response?.data.data)
            }
        })
    }

    const getAircraftFamily = () => {
        globalGetService(`config-data/aircraft-family/?lite=true`)
        .then(response => {
            if (checkApiStatus(response)) {
                setAircraftFamilyInfo(response?.data.data)
            }
        })
    }


    const isDataChanged = () =>{
        const originalData = addEditAircraftTypes?.data || {};
        return(
            data?.name !== originalData?.name ||
            data?.aircraft_body_type?.label !== originalData?.aircraft_body_type?.label ||
            data?.no_of_engines !== originalData?.no_of_engines ||
            data?.no_of_landing_gears !== originalData?.no_of_landing_gears ||
            data?.aircraft_family?.id !== originalData?.aircraft_family?.id ||
            data?.has_propeller !== originalData?.has_propeller ||
            data?.has_apu !== originalData?.has_apu ||
            data?.remarks !== originalData?.remarks
        );
    };
    
    const onAddEditAircraftTypes = () => {
        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter Name',
            no_of_engines: data?.no_of_engines ? '' : 'Please enter No. of Engines',
            no_of_landing_gears: data?.no_of_landing_gears ? '' : 'Please enter No. of Landing Gears',
            aircraft_family: data?.aircraft_family ? '' : 'Please select Aircraft Family',
            aircraft_body_type: data?.aircraft_body_type ? '' : 'Please select Aircraft Body Type'
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);

            let payload = Object.assign({}, data);

            payload = {
                id:payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                aircraft_body_type: payload?.aircraft_body_type ? payload?.aircraft_body_type : {value: 3, label: '--N/A--'},
                no_of_engines: payload?.no_of_engines ? payload?.no_of_engines : null,
                no_of_landing_gears: payload?.no_of_landing_gears ? payload?.no_of_landing_gears : null,
                aircraft_family: payload?.aircraft_family ? payload?.aircraft_family : null,
                has_propeller: payload?.has_propeller ? payload?.has_propeller : false,
                has_apu: payload?.has_apu ? payload?.has_apu : false,
                remarks: payload?.remarks ? payload?.remarks : ''
            }

            const apiUrl = data?.id ? `config-data/aircraft-type/bulk-update/` : `config-data/aircraft-type/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Aircraft Types Data Updated Successfully' : 'Aircraft Types Data Added Successfully',
                            page_title: 'Config Data : Aircraft Types',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Aircraft Types Updation Failed' : 'Aircraft Types Data Added Failed',
                            page_title: 'Config Data : Aircraft Types',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }

    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit' : modeType === 'view' ? 'Veiw' : 'Add'} Aircraft Type
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 50 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    name='no_of_engines'
                                    label='No. Of Engines'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.no_of_engines || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 1 }}
                                    onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange('no_of_engines', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.no_of_engines || ''}
                                    helperText={error?.no_of_engines || ''}
                                    onFocus={() => setError({ ...error, no_of_engines: '' })}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    name='no_of_landing_gears'
                                    label='No. Of Landing Gear'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.no_of_landing_gears || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 1 }}
                                    onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange('no_of_landing_gears', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.no_of_landing_gears || ''}
                                    helperText={error?.no_of_landing_gears || ''}
                                    onFocus={() => setError({ ...error, no_of_landing_gears: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    options={(aircraftFamilyInfo || []).filter((item) => item.id !== data?.aircraft_family?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="aircraft_family"
                                    disabled={modeType === 'view'}
                                    value={data?.aircraft_family || null}
                                    onChange={(e, value) => onFieldChange('aircraft_family', value)}
                                    renderInput={params => <TextField placeholder={'Please select Aircraft Family'}  {...params} label={'Aircraft Family'} error={error?.aircraft_family || ''} helperText={error?.aircraft_family || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, aircraft_family: '' })}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <Autocomplete
                                    getOptionLabel={option => option?.label}
                                    options={pltConstants}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="aircraft_body_type"
                                    disabled={modeType === 'view'}
                                    value={data?.aircraft_body_type || null}
                                    onChange={(e, value) => { onFieldChange('aircraft_body_type', value); }}
                                    renderInput={params => <TextField  onFocus={() => setError({ ...error, aircraft_body_type: '' })} required placeholder={'Please select Aircraft Body Type'}  {...params} label={'Aircraft Body Type'} error={error?.aircraft_body_type || ''} helperText={error?.aircraft_body_type || ''} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <FormGroup row style={{justifyContent:"space-between", marginTop:"20px"}}>
                                    {!gaTelesisInstance ?
                                        <FormControlLabel
                                            control={<Checkbox checked={data?.has_propeller} onChange={(e) => onFieldChange('has_propeller', e.target.checked)} name="hasPropeller" color="primary" size="small" />}
                                            label="Has Propeller"
                                        /> : null}
                                    <FormControlLabel
                                        control={<Checkbox checked={data?.has_apu} onChange={(e) => onFieldChange('has_apu', e.target.checked)} name="hasApu" color="primary" size="small"/>}
                                        label="Has APU"
                                    />
                                </FormGroup>
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Aircraft Types form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditAircraftTypes(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types', item_type: 'Save Button', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Aircraft Types form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item}
                />)}
        </>
    )
}
export default AddEditAircraftTypes;